export const GET_MONTH_REVENUE = 'GET_MONTH_REVENUE';
export const SUCCESS_GET_MONTH_REVENUE = 'SUCCESS_GET_MONTH_REVENUE';
export const FAIL_GET_MONTH_REVENUE = 'FAIL_GET_MONTH_REVENUE';

export const INIT_REVENUE = 'INIT_REVENUE';
